module.exports = __webpack_public_path__ + "img/pic_result_nocourse@2x.119163c7.png";